import { Api } from '@api';

import { actionCreatorAsync } from '../creator';

import {
	IActionBodyDimensionsLogUpdatePayload,
	IActionBodyDimensionsLogUpdatePayloadDone,
	IActionBodyDimensionsLogUpdatePayloadError,
} from './types';

export const bodyDimensionsLogUpdate = actionCreatorAsync<
	IActionBodyDimensionsLogUpdatePayload,
	IActionBodyDimensionsLogUpdatePayloadDone,
	IActionBodyDimensionsLogUpdatePayloadError
>(
	'bodyDimensionsLogUpdate',
	async (params) => {
		const { bodyDimensionsLog } = params;
		const { id, ...body } = bodyDimensionsLog;
		const { data } = await Api.bodyDimensionsLog.update({
			params: { id },
			body,
		});

		return data;
	},
);
